import useAxios from "@/composables/useAxios"

export async function useSanctumQuery() {
    return await useAxios().axios.get("/sanctum/csrf-cookie")
}
